import { useEffect } from "react";

/**
 * Listens for keyboard shortcuts.
 * cmd+K / ctrl+K -> onPalette
 * Number 1-7    -> onNumber(n)  (sidebar shortcuts)
 */
export function useKeyboard({ onPalette, onNumber }) {
  useEffect(() => {
    const handler = (e) => {
      const meta = e.metaKey || e.ctrlKey;
      const tag = (e.target?.tagName || "").toLowerCase();
      const inField = tag === "input" || tag === "textarea" || e.target?.isContentEditable;
      if (meta && (e.key === "k" || e.key === "K")) {
        e.preventDefault();
        onPalette?.();
        return;
      }
      if (!inField && /^[1-7]$/.test(e.key)) {
        onNumber?.(Number(e.key));
      }
    };
    window.addEventListener("keydown", handler);
    return () => window.removeEventListener("keydown", handler);
  }, [onPalette, onNumber]);
}
